<template>
  <div>
    <ts-dialog :visible.sync="visible" width="600px" center :show-close="false">
      <div class="publish-dialog">
        <p class="publish-title">Where do you want to publish your assets?</p>
        <div class="publish-buttons">
          <ts-button circle>
            <ts-icon icon="pinterest" color="#acbacc"></ts-icon>
          </ts-button>
          <ts-button circle>
            <ts-icon icon="snapchat" color="#acbacc"></ts-icon>
          </ts-button>
          <ts-button circle>
            <ts-icon icon="tiktok" color="#acbacc"></ts-icon>
          </ts-button>
          <ts-button circle>
            <ts-icon icon="youtube" color="#acbacc"></ts-icon>
          </ts-button>
          <ts-button circle>
            <ts-icon icon="facebook" color="#acbacc"></ts-icon>
          </ts-button>
          <ts-button circle>
            <ts-icon icon="instagram" color="#acbacc"></ts-icon>
          </ts-button>
        </div>
      </div>
    </ts-dialog>
    <ts-button type="primary" size="small" filled @click="handlePublishAssetsClick" style="display: none">
      Publish to media library
    </ts-button>
  </div>
</template>

<style lang="scss" scoped>
.publish-dialog {
  padding-bottom: 20px;

  .publish-title {
    font-family: Roboto;
    font-size: 24px;
    text-align: center;
    color: #6d7587;
  }

  .publish-buttons {
    display: flex;
    justify-content: center;
    margin-top: 40px;

    > * {
      margin: 5px;
    }
  }
}
</style>

<script>
export default {
  props: {
    assets: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false
    };
  },
  methods: {
    handlePublishAssetsClick() {
      this.visible = true;
    }
  }
};
</script>
